module.exports = __webpack_public_path__ + "static/media/icon-cwb-logo.9c37097f.svg";